import JSCookie from 'js-cookie';
import $ from 'jquery';

export default function addBodyClasses() {
  // User is logged in to CMS
  if (JSCookie.get('ti_wordpress')) {
    $('body').addClass('is-logged-in');
  }
}



// WEBPACK FOOTER //
// ./~/unicorn/public/src/utils/body-classes.js